export default defineNuxtRouteMiddleware((to, from) => {
    const excludedPaths = ['/shop/', '/store/', '/tienda/', '/boutique/', '/negozio/'];

    if (to.path !== '/' && to.path.endsWith('/') && !excludedPaths.includes(to.path)) {
        const { path, query, hash } = to;
        const nextPath = path.replace(/\/+$/, '') || '/';
        const nextRoute = { path: nextPath, query, hash };
        return navigateTo(nextRoute, { redirectCode: 301 });
    }
})
